import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'

import VideosNav from '../../../components/videos-nav'
import LookingForMore from '../../../components/looking-for-more'
import VideoList from '../../../components/video-list'
import ResourcesNav from '../../../components/resources-nav'
import Layout from '../../../components/layout'

export default class Videos extends React.Component {
  render() {
    const prek = get(this, 'props.data.prek.edges')
    const siteTitle = get(this, 'props.data.site.siteMetadata.title')
    const metaDescription = `PreK Videos for teaching Math. Free teaching resources from ${siteTitle}`
    return (
      <Layout pageTitle="PreK Videos" description={metaDescription}>
        <ResourcesNav path={this.props.path} />
        <VideosNav path={this.props.path} />

        <h1>PreK Videos</h1>
        <VideoList resources={prek} />
        <hr />
        <LookingForMore />
      </Layout>
    )
  }
}

export const Query = graphql`
  query PreKQuery {
    site {
      siteMetadata {
        title
      }
    }
    prek: allContentfulResource(
      filter: { collections: { eq: "prek-videos" } }
      sort: { fields: slug }
    ) {
      edges {
        node {
          slug
          title
          description {
            childMarkdownRemark {
              html
            }
          }
          file {
            title
            file {
              url
            }
          }
        }
      }
    }
  }
`
